import PropTypes from 'prop-types';
import { Route, useLocation, Redirect } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import store from '~/store';

import DefaultLayout from '~/pages/_layouts/default';
import Loading from '~/components/Loading';
import {
  EmailFeatureFlags,
  FeatureFlags,
  useFeatureFlagStore,
} from '~/zustand/featureFlag/useFeatureFlagStore';
import { useEnsureProfile } from '~/hooks/useEnsureProfile';
import { useTokenStore } from '~/store/modules/token/useTokenStore';

interface RouteType {
  component: any;
  tabName?: string;
  path: string;
  exact?: boolean;
  isPrivate?: boolean;
  logout?: boolean;
  noLayout?: boolean;
  requiresFeatureFlag?: FeatureFlags;
  requiresEmailFeatureFlag?: EmailFeatureFlags;
}

export default function RouteWrapper({
  component: Component,
  path,
  exact,
  isPrivate,
  noLayout,
  requiresFeatureFlag,
  requiresEmailFeatureFlag,
  // #FIXME
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logout,
  ...rest
}: RouteType) {
  // #FIXME
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
  const dispatch = useDispatch();
  const location = useLocation();

  // #FIXME
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars, @typescript-eslint/no-explicit-any
  const state: any = store.getState();
  const tokens = useTokenStore.getTokens();
  const profile = useEnsureProfile();

  const {
    isFeatureFlagEnabled,
    isEmailFeatureFlagEnabled,
    isLoading: isFeatureFlagLoading,
    isSuccessful: isFeatureFlagSuccessful,
  } = useFeatureFlagStore(state => ({
    isFeatureFlagEnabled: state.isFeatureFlagEnabled,
    isEmailFeatureFlagEnabled: state.isEmailFeatureFlagEnabled,
    isLoading: state.isLoading,
    isSuccessful: state.isSuccessful,
  }));

  const atLeastOneFlagRequired = requiresFeatureFlag || requiresEmailFeatureFlag;

  if (atLeastOneFlagRequired) {
    if (isFeatureFlagLoading) {
      return <Loading loading />;
    }

    if (isFeatureFlagSuccessful) {
      const isFeatureFlagValid = requiresFeatureFlag
        ? isFeatureFlagEnabled(requiresFeatureFlag)
        : false;
      const isEmailFeatureFlagValid = requiresEmailFeatureFlag
        ? isEmailFeatureFlagEnabled(profile.veiling_claim_type_email, requiresEmailFeatureFlag)
        : false;
      const atLeastOneFlagValid = isFeatureFlagValid || isEmailFeatureFlagValid;

      if (!atLeastOneFlagValid) {
        return <Redirect to="/" />;
      }
    }
  }

  if (isPrivate && !tokens.accessToken) {
    const redirect = location.pathname.replace(/^\//, '');
    const ssoUrl = `${process.env.REACT_APP_SINGLE_SIGNON_REDIRECT}?redirect=${redirect}`;

    window.location.href = ssoUrl;
    return null;
  }

  const getLayout = (props: any) => {
    if (location.pathname === '/oauth/') {
      return (
        <>
          <Component {...props} />
          <Loading loading />
        </>
      );
    }
    if (noLayout) {
      return <Component {...props} />;
    }
    return <DefaultLayout />;
  };

  return <Route path={path} exact={exact} {...rest} render={props => getLayout(props)} />;
}

RouteWrapper.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};
